import {
  SearchAvailableGeoAreasForAppVariantRequest,
  SharedAppApi
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useSharedAppApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new SharedAppApi(configuration),
    [configuration]
  );

  const searchGeoAreas = useCallback(
    (requestParameters: SearchAvailableGeoAreasForAppVariantRequest) =>
      apiInstance
        .searchAvailableGeoAreasForAppVariant(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  return {
    searchGeoAreas
  };
};
